/*CONSTANTS*/
import {CLIENT_IS_NOT_LOGGED_IN, ErrorCategory, GENERIC_ERROR, RESET_ERROR} from '../../constants/ErrorConstants';
import {FailedAction} from '../../@types/actions';
import {ErrorsReducer as State} from '../../@types/reducers';
import {LOGIN, LOGIN_FAILED} from '../../constants/LoginConstants';


const initialState: State = {
    code: '',
    message: '',
    type: ErrorCategory.NO_ERROR,
    placeholder: {}
};

const ErrorsReducer = (state = initialState, action: FailedAction): State => {
    switch (action.type) {
        case LOGIN_FAILED: {
            return {
                ...state,
                code: 401,
                message: "Username or password is incorrect. Please try again.",
                placeholder: {},
                type: ErrorCategory.LOGIN
            };
        }
        case GENERIC_ERROR:
            return {
                ...state,
                code: action.error.code,
                message: action.error.message,
                placeholder: action.error.placeholder,
                type: ErrorCategory.GENERIC
            };
        case LOGIN:
        case CLIENT_IS_NOT_LOGGED_IN:
        case RESET_ERROR:
            return initialState;
        default:
            return state;
    }
};

export default ErrorsReducer;
